import React, { PropsWithChildren, useRef } from "react";
import styled from "styled-components";
import lang from "../functions/lang";
import { ScrollBarConfig } from "../functions/ScrollBarConfig";
import { useGoogle } from "../Hooks/useGoogle";
import { Store } from "../interfaces/IStore";
import ChevronIcon from "./Icons/ChevronIcon";
import XIcon from "./Icons/XIcon";
import { StoreContent } from "./StoreContent";
const Card = styled.div<{ isOpen: boolean }>`
  position: absolute;
  z-index: 2;
  padding-top: 5.4rem;
  bottom: 0;
  top: 0;
  left: ${(props) => (props.isOpen ? "23rem" : "2rem")};
  overflow: hidden;
  display: flex;
  flex-flow: column;
  transition: 0.3s;
`;

const CardOuterWrapper = styled.div`
  padding-right: 1rem;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-flow: column;
  flex-grow: 1;
  flex-shrink: 1;
  border-top-right-radius: 1.6rem;
  width: 100%;
  background: white;
  overflow: auto;
  ${ScrollBarConfig}
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
`;

const HeaderInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const Header = styled.h4`
  margin: 0;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.5px;
  color: #522398;
`;

const CardContentWrapper = styled.div`
  padding: 1rem;
  padding-right: 0;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    border-radius: 30px;
  }
`;

const CardFooterWrapper = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
  flex-grow: 0;
  flex-shrink: 0;
  background-color: #fff;
  position: absolute;
  padding: 1rem;
  display: flex;
  flex-direction: column;
`;

const A = styled.a`
  color: #522398;
  font-size: 18px;
  text-decoration: none;
  padding-left: 11px;
`;

let MoreInfoContainer = styled.div``;

interface IStoreCard {
  currentStore: Store | undefined;
  closeStore: () => void;
  fromFilter: boolean;
  back: () => void;
}

const MobileStoreCard = ({
  currentStore,
  closeStore,
  fromFilter,
  back,
}: PropsWithChildren<IStoreCard>) => {
  const StoreModalOuterRef = useRef() as React.MutableRefObject<HTMLDivElement>;

  return (
    //@ts-ignore
    <>
      <HeaderWrapper>
        <HeaderInnerWrapper>
          {fromFilter ? (
            <ChevronIcon
              onClick={back}
              style={{
                transform: "rotate(180deg)",
                marginRight: "1rem",
                alignSelf: "baseline",
              }}
            />
          ) : null}
          <Header>
            {lang("storeCard.header", window.data?.language || "en")}
          </Header>
        </HeaderInnerWrapper>
        <XIcon onClick={closeStore} />
      </HeaderWrapper>
      <CardOuterWrapper>
        <CardWrapper>
          {/* Close Icon */}

          <CardContentWrapper>
            <StoreContent currentStore={currentStore} />
          </CardContentWrapper>
        </CardWrapper>
      </CardOuterWrapper>
    </>
  );
};

export default MobileStoreCard;
